import { useCallback, useState } from 'react';
import { useEffect } from 'react';
import { TripProps } from '../trip-card';
import defaultImg from '../../Assets/trips/trip-1.png';
import { chunkArray } from '../../services/service-utils';
import { Row, Col } from 'react-bootstrap';
import { getAppImagesUrl } from '../../services/service-utils';
import tripsService from '../../services/trips/trips.service';
import TripItemCard from './trip';
import { useTrips } from '../contexts/trips-context';
import DeleteModal from '../modals/settings/delete-modal';
import { IdType } from '../types/card';
import EditTripModal from '../modals/trip/edit-trip-modal';
import CloneTripModal from '../modals/trip/clone-trip-modal';
import { useSorting } from '../contexts/sorting-context';
import { ITripModelSummary } from '../../Models/trips/trip-summary.model';
import { get } from 'http';

import { useNavigate } from 'react-router-dom';
import { TripCard } from './trip2';
import { getLastTripSection } from '../../utils/trip-view-state';

const img = {
  src: defaultImg,
  alt: 'this is a test'
};

interface TripCardListProps {
  direction?: 'horizontal' | 'vertical';
  searchQuery?: string;
}

function TripCardList({ direction, searchQuery }: TripCardListProps) {
  const navigate = useNavigate();
  const { trips, setTrips, refreshTrips, setRefreshTrips } = useTrips();
  const { sort } = useSorting();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [tripId, setTripId] = useState<IdType | null>(null);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [showCloneModal, setShowCloneModal] = useState<boolean>(false);
  const [showPublishModal, setShowPublishModal] = useState<boolean>(false);

  useEffect(() => {
    console.log('here is teh app images url', getAppImagesUrl());
  }, []);

  // Fetch trips on mount and when refreshTrips or sort changes
  const getData = useCallback(async () => {
    console.log(
      '🚨 TripCardList.getData() called - Stack trace:',
      new Error().stack
    );

    let response;

    // If there's a search query, use search API
    if (searchQuery && searchQuery.trim() !== '') {
      console.log('🔍 Searching trips with query:', searchQuery);
      const searchResult = await tripsService.searchTrips(
        searchQuery,
        currentPage,
        itemsPerPage
      );
      response = searchResult.trips;
    } else {
      // Otherwise use regular get summaries
      response = await tripsService.getTrips_Summaries(sort);
    }

    if (!response || response.length === 0) {
      setTrips([]);
      return;
    }

    setTrips([...response]);
  }, [setTrips, sort, searchQuery, currentPage]);

  useEffect(() => {
    getData();
    // Only setRefreshTrips(false) if refreshTrips was true
    if (refreshTrips) {
      setRefreshTrips(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getData, refreshTrips, sort]);

  // Calculate the trips to be displayed on the current page
  const indexOfLastTrip = currentPage * itemsPerPage;
  const indexOfFirstTrip = indexOfLastTrip - itemsPerPage;
  const currentTrips = trips.slice(indexOfFirstTrip, indexOfLastTrip);

  // Calculate the total number of pages
  const totalPages = Math.ceil(trips.length / itemsPerPage);

  // Handle page change
  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const chunkedTrips = chunkArray(trips, 6);

  const handleShowPublishModal = (id: IdType) => {
    setShowPublishModal(true);
    setTripId(id);
  };

  const handleShowCloneModal = (id: IdType) => {
    setShowCloneModal(true);
    setTripId(id);
  };

  const handleShowEditModal = (id: IdType) => {
    setShowEditModal(true);
    setTripId(id);
  };

  const handleShowDeleteModal = (id: IdType) => {
    setShowDeleteModal(true);
    setTripId(id);
  };

  return (
    <Row
      style={
        {
          '--bs-gutter-x': '20px',
          '--bs-gutter-y': '20px'
        } as React.CSSProperties
      }
    >
      {trips?.map((trip, index) => {
        return (
          <Col
            xxl={3}
            lg={4}
            sm={6}
            key={index}
          >
            {/* <TripItemCard
              key={index}
              id={trip.id}
              title={trip.title}
              date={trip.createdAt}
              createdBy={trip.createdBy}
              imgUrl={trip.imgUrl}
              modalHandles={{
                showClone: handleShowCloneModal,
                showEdit: handleShowEditModal,
                showDelete: handleShowDeleteModal,
                showPublish: handleShowPublishModal
              }}
            /> */}
            <TripCard
              trip={trip}
              onClick={() =>
                navigate(
                  `/app/trip/${trip.id}/view/${getLastTripSection(trip.id)}`
                )
              }
              onDelete={() => {
                // Refresh trips list after successful delete
                getData();
              }}
              onUpdate={() => {
                getData();
              }}
            />
          </Col>
        );
      })}
      <DeleteModal
        title={`Delete Trip: ${
          trips?.find((trip) => trip.id === tripId)?.title || 'Trip'
        }`}
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
      />
      <EditTripModal
        id={tripId}
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
      />
      <CloneTripModal
        id={tripId}
        show={showCloneModal}
        handleClose={() => setShowCloneModal(false)}
      />
    </Row>
  );
}

export default TripCardList;
